module.exports = __webpack_public_path__ + "static/media/AZ.9c35f3a0.png";